import request from "axios";
import qs from "qs";

/**************************************
 *Module：basequanjucanshuAPIJS
 *Author：李晓伟
 *Time: 2019-08-16 15:36:48
 **************************************/

export const geturl = (url, params) => {
  return request({
    url: url,
    method: "get",
    params: {
      ...params
    }
  });
};

export const postfile = (url, fd) => {
  return request.post(url, fd, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

export const geturltime = (url, params, timeout) => {
  return request({
    url: url,
    method: "get",
    params: {
      ...params
    },
    timeout: timeout
  });
};

export const posturl = (url, row, params) => {
  return request({
    url: url,
    method: "post",
    data: row, //body
    params: {
      ...params
    }
  });
};

//组合参数传递
export const posturl2 = (url, row, params) => {
  return request({
    url: url,
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: qs.stringify(row), //body
    params: {
      ...params
    }
  });
};

//提交
export const posturlblob = (url, row) => {
  return request({
    url: url,
    method: "post",
    data: qs.stringify(row),
    responseType: "blob", // important
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};



// WEBPACK FOOTER //
// ./src/ajax.js